import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalFooter, ModalHeader } from "reactstrap"
import ModalBody from "reactstrap/es/ModalBody"
import { Tooltip } from 'antd'

class CloseBox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            closing: false,
            modal: false,
        }
    }

    _setModal = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

    _handleConfirmClickClose = (e) => {
        e.preventDefault()

        const { box, barcodeError, confirmWarning } = this.props
        const barcodes = barcodeError.find(item => item.boxID === box._id)
        // Cần xác nhận khi có barcode quét sai HOẶC khi thùng còn đơn chưa đóng đủ.
        // Gộp vào cùng 1 modal vì hai điều kiện có thể xảy ra đồng thời — nếu tách
        // thành 2 modal thì người dùng phải xác nhận 2 lần hoặc modal che nhau.
        const needConfirm = barcodes !== undefined || !!confirmWarning

        this.setState({
            modal: needConfirm
        }, () => {
            !needConfirm && this._handleClickClose()
        })
    }

    _handleClickClose = async () => {

        if (this.state.closing) return false

        // Chốt an toàn tầng hai: nút đã disable nhưng chặn thêm ở đây để bịt cả
        // đường đi qua nút "Đóng thùng" trong modal xác nhận
        if (this.props.disabledReason) return false

        const r = window.confirm('Bạn có chắc chắc muốn đóng thùng này?')
        if (!r) return false

        this.setState({
            closing: true,
            modal: false,
        })

        try {
            await this.props.onClose()

            this.setState({
                closing: false
            })
        } catch (e) {
            this.setState({
                closing: false,
            })
        }
    }

    _renderCloseButton = (className) => {
        const { disabledReason } = this.props
        const { closing } = this.state
        const blocked = !!disabledReason

        const button = (
            <button
                disabled={closing || blocked}
                onClick={this._handleConfirmClickClose}
                className={className}
            >
                Đóng thùng
            </button>
        )

        // Không bọc gì khi nút không bị chặn -> DOM của thùng thường giữ nguyên như cũ
        if (!blocked) return button

        // Tooltip của antd không bắt được mouse event trên <button disabled> nên phải
        // bọc thêm <span>, nếu không tooltip sẽ không bao giờ hiện và người dùng chỉ
        // thấy nút xám mà không biết lý do.
        return (
            <Tooltip title={disabledReason}>
                <span className="d-inline-block">{button}</span>
            </Tooltip>
        )
    }

    render() {
        const { box, barcodeError, position, confirmWarning } = this.props
        const barcodes = barcodeError.find(item => item.boxID === box._id)
        const { status } = box

        if (status !== 'opening') return null

        const { modal } = this.state

        return (
            <div className={position === 'footer' ? "CloseBox card-footer" : "CloseBox"}>
                {position === 'footer' &&
                    <div className="d-flex justify-content-center">
                        {this._renderCloseButton("btn btn-success")}
                    </div>
                }
                {position !== 'footer' && this._renderCloseButton("btn btn-success mx-1")}
                {modal && (
                    <Modal isOpen={modal} toggle={this._setModal}>
                        <ModalHeader toggle={this._setModal}>
                            {confirmWarning ? 'Xác nhận đóng thùng' : 'Danh sách barcode quét sai'}
                        </ModalHeader>
                        <ModalBody>
                            {!!confirmWarning && (
                                <div className="alert alert-warning mb-2">{confirmWarning}</div>
                            )}
                            {barcodes !== undefined && barcodes.barcodes.length > 0 && (
                                <div>
                                    {/* tiêu đề modal đã đổi thành "Xác nhận đóng thùng" nên
                                        cần nói rõ khối này là gì; thùng thường giữ nguyên như cũ */}
                                    {!!confirmWarning && <div className="mb-1">Danh sách barcode quét sai:</div>}
                                    {barcodes.barcodes.map((item, index) => {
                                        return (
                                            <div className="mb-1" key={index}><strong>#{item}</strong></div>
                                        )
                                    })}
                                </div>
                            )}
                        </ModalBody>
                        <ModalFooter className="d-flex justify-content-between">
                            <Button color="default" onClick={this._setModal}>Hủy </Button>
                            <Button color="primary" onClick={this._handleClickClose}>Đóng thùng</Button>
                        </ModalFooter>
                    </Modal>
                )}
            </div>
        )
    }
}

CloseBox.propTypes = {
    box: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    // Có giá trị -> disable nút "Đóng thùng" và hiện tooltip giải thích lý do
    disabledReason: PropTypes.string,
    // Có giá trị -> vẫn cho đóng nhưng bắt xác nhận lại qua modal
    confirmWarning: PropTypes.string,
}

CloseBox.defaultProps = {
    disabledReason: '',
    confirmWarning: '',
}

export default CloseBox
